import { SidenavUtils } from '@/common/utils/SideNavUtils';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';

const scSideNav = {
  id: 'sc',
  shortName: 'S & C',
  role: 'SC_VIEW',
  displayName: 'Sales & Concessions',
  icon: fas.faMoneyCheckAlt,
  precedence: 1,
  children: [
    // Organization Menu
    SidenavUtils.orgMenu('sc'),

    // Direct Sales
    {
      id: 'scDirSalesMenu',
      displayName: 'Direct Sales',
      role: 'SC_DIR_SALE_VIEW',
      icon: fas.faFileInvoice,
      precedence: 2,
      children: [
        {
          id: 'scDirSale',
          displayName: 'Sales',
          role: 'SC_DIR_SALE_VIEW',
          icon: fas.faFileInvoice,
          route: '/sc/dir-sale',
          precedence: 2,
        },
        {
          id: 'scDirSaleDashboard',
          displayName: 'Sale Dashboard',
          role: 'SC_DIR_SALE_VIEW',
          icon: fas.faChartBar,
          route: '/sc/dir-sale-dashboard',
          precedence: 3,
        },
        {
          id: 'scAdj',
          displayName: 'Adjustments',
          role: 'SC_ADJ_VIEW',
          icon: fas.faSlidersHSquare,
          route: '/sc/adj',
          precedence: 4,
        },
      ],
    },

    // Chargeback Section
    {
      id: 'scChbkMenu',
      displayName: 'Chargebacks',
      role: 'SC_CHBK_CLAIM_VIEW',
      icon: fas.faWarehouse,
      precedence: 4,
      children: [
        {
          id: 'scIndirSale',
          displayName: 'Indirect Sales',
          role: 'SC_INDIR_SALE_VIEW',
          icon: fas.faFileInvoice,
          route: '/sc/indir-sale',
          precedence: 3,
        },
        {
          id: 'scChbkClaim',
          displayName: 'Claims',
          role: 'SC_CHBK_CLAIM_VIEW',
          icon: fas.faClipboard,
          route: '/sc/chbk-claim',
          precedence: 6,
        },
        {
          id: 'scChbkPymt',
          displayName: 'Payments',
          role: 'SC_PYMT_VIEW',
          icon: fas.faDollarSign,
          route: '/sc/pymt/chbk',
          precedence: 7,
        },
        {
          id: 'scChbkDashboard',
          displayName: 'Indirect Sale Dashboard',
          role: 'SC_CHBK_CLAIM_VIEW',
          icon: fas.faChartBar,
          route: '/sc/chbk-dashboard',
          precedence: 5,
        },
        {
          id: 'scChbkFinDashboard',
          displayName: 'Financial Dashboard',
          role: 'SC_CHBK_CLAIM_VIEW',
          icon: fas.faChartBar,
          route: '/sc/chbk-fin-dashboard',
          precedence: 6,
        },
        {
          id: 'scChannelData',
          displayName: 'Channel Data',
          role: 'SC_CHANNEL_DATA_VIEW',
          icon: fas.faFileChartLine,
          route: '/sc/channel-data',
          precedence: 8,
        },
        {
          id: 'scShpmnt',
          displayName: 'Shipments',
          role: 'SC_SHPMNT_VIEW',
          icon: fas.faBoxOpen,
          route: '/sc/shpmnt',
          precedence: 9,
        },
        {
          id: 'scAcctBal',
          displayName: 'Account Balance',
          role: 'SC_ACCT_BAL_VIEW',
          icon: fas.faFileChartLine,
          route: '/sc/acct-bal',
          precedence: 10,
        },
      ],
    },

    // Incentive Section
    {
      id: 'scInctvMenu',
      displayName: 'Incentive',
      role: 'SC_INCTV_CLAIM_VIEW',
      icon: fas.faTag,
      precedence: 11,
      children: [
        {
          id: 'scInctvInv',
          displayName: 'Invoices',
          role: 'SC_INCTV_INV_VIEW',
          icon: fas.faFilePrescription,
          route: '/sc/inctv-inv',
          precedence: 17,
        },
        {
          id: 'scInctvClaim',
          displayName: 'Claims',
          role: 'SC_INCTV_CLAIM_VIEW',
          icon: fas.faClipboard,
          route: '/sc/inctv-claim',
          precedence: 12,
        },
        {
          id: 'scInctvPymt',
          displayName: 'Payments',
          role: 'SC_PYMT_VIEW',
          icon: fas.faDollarSign,
          route: '/sc/pymt/inctv',
          precedence: 13,
        },
      ],
    },

    // Managed Care Section
    {
      id: 'scMcoMenu',
      displayName: 'Managed Care',
      role: 'SC_MCO_CLAIM_VIEW',
      icon: fas.faClinicMedical,
      precedence: 14,
      children: [
        {
          id: 'scMcoInvDashboard',
          displayName: 'Invoice Dashboard',
          role: 'SC_MCO_INV_VIEW',
          icon: fas.faChartBar,
          route: '/sc/mco-dashboard',
          precedence: 15,
        },
        {
          id: 'scMcoFinDashboard',
          displayName: 'Financial Dashboard',
          role: 'SC_MCO_INV_VIEW',
          icon: fas.faChartBar,
          route: '/sc/mco-fin-dashboard',
          precedence: 16,
        },
        {
          id: 'scMcoInv',
          displayName: 'Invoices',
          role: 'SC_MCO_INV_VIEW',
          icon: fas.faFilePrescription,
          route: '/sc/mco-inv',
          precedence: 17,
        },
        {
          id: 'scMcoClaim',
          displayName: 'Claims',
          role: 'SC_MCO_CLAIM_VIEW',
          icon: fas.faClipboard,
          route: '/sc/mco-claim',
          precedence: 18,
        },
        {
          id: 'scMcoPymt',
          displayName: 'Payments',
          role: 'SC_PYMT_VIEW',
          icon: fas.faDollarSign,
          route: '/sc/pymt/mco',
          precedence: 19,
        },
      ],
    },

    // Medicaid Section
    {
      id: 'scMcdMenu',
      displayName: 'Medicaid',
      role: 'SC_MCD_INV_VIEW',
      icon: fas.faHospitalUser,
      precedence: 20,
      children: [
        {
          id: 'scMcdInv',
          displayName: 'Invoices',
          role: 'SC_MCD_INV_VIEW',
          icon: fas.faChartBar,
          route: '/sc/mcd-inv',
          precedence: 22,
        },
        {
          id: 'scMcdClaim',
          displayName: 'Claims',
          role: 'SC_MCD_CLAIM_VIEW',
          icon: fas.faClipboard,
          route: '/sc/mcd-claim',
          precedence: 25,
        },
        {
          id: 'scMcdPymt',
          displayName: 'Payments',
          role: 'SC_PYMT_VIEW',
          icon: fas.faDollarSign,
          route: '/sc/pymt/mcd',
          precedence: 26,
        },
        {
          id: 'scMcdInvDashboard',
          displayName: 'Invoice Dashboard',
          role: 'SC_MCD_INV_VIEW',
          icon: fas.faChartBar,
          route: '/sc/mcd-dashboard',
          precedence: 20,
        },
        {
          id: 'scMcdFinDashboard',
          displayName: 'Financial Dashboard',
          role: 'SC_MCD_INV_VIEW',
          icon: fas.faChartBar,
          route: '/sc/mcd-fin-dashboard',
          precedence: 20,
        },
      ],
    },

    // MFP Section
    {
      id: 'scMfpMenu',
      displayName: 'MFP',
      role: 'SC_MFP_VIEW',
      icon: fas.faNotesMedical,
      precedence: 25,
      children: [
        {
          id: 'scMfpBoard',
          displayName: 'Lifecycle Board',
          role: 'SC_MFP_CLAIM_VIEW',
          icon: fas.faChartBar,
          route: '/sc/board/mfp-claim',
          precedence: 26,
        },
        {
          id: 'scMfpUtil',
          displayName: 'Utilizations',
          role: 'SC_MFP_UTIL_VIEW',
          icon: fas.faFilePrescription,
          route: '/sc/mfp-util',
          precedence: 27,
        },
        {
          id: 'scMfpClaim',
          displayName: 'Claims',
          role: 'SC_MFP_CLAIM_VIEW',
          icon: fas.faClipboard,
          route: '/sc/mfp-claim',
          precedence: 28,
        },
        {
          id: 'scMfpPymt',
          displayName: 'Payments',
          role: 'SC_MFP_PYMT_VIEW',
          icon: fas.faDollarSign,
          route: '/sc/mfp-pymt',
          precedence: 29,
        },
        {
          id: 'scMfpCredit',
          displayName: 'Credits',
          role: 'SC_MFP_CREDIT_VIEW',
          icon: fas.faHandsUsd,
          route: '/sc/mfp-credit',
          precedence: 30,
        },
      ],
    },

    // Transactions Section
    {
      id: 'trx',
      displayName: 'Transactions',
      role: 'SC_TRX_VIEW',
      icon: fas.faListUl,
      precedence: 33,
      children: [
        {
          id: 'trxDs',
          displayName: 'Direct Sales',
          role: 'SC_TRX_DS_VIEW',
          icon: fas.faFileInvoice,
          route: '/sc/trx-viewer/TRX_DS',
          precedence: 34,
        },
        {
          id: 'trxIs',
          displayName: 'Indirect Sales',
          role: 'SC_TRX_IS_VIEW',
          icon: fas.faWarehouse,
          route: '/sc/trx-viewer/TRX_IS',
          precedence: 35,
        },
        {
          id: 'trxInctv',
          displayName: 'Incentive',
          role: 'SC_TRX_INCTV_VIEW',
          icon: fas.faTag,
          route: '/sc/trx-viewer/TRX_INCTV',
          precedence: 36,
        },
        {
          id: 'trxMco',
          displayName: 'Managed Care',
          role: 'SC_TRX_MCO_VIEW',
          icon: fas.faClinicMedical,
          route: '/sc/trx-viewer/TRX_MCO',
          precedence: 37,
        },
        {
          id: 'trxMcd',
          displayName: 'Medicaid',
          role: 'SC_TRX_MCD_VIEW',
          icon: fas.faHospitalUser,
          route: '/sc/trx-viewer/TRX_MCD',
          precedence: 38,
        },
        {
          id: 'trxRb',
          displayName: 'Rebate Payments',
          role: 'SC_TRX_RB_VIEW',
          icon: fas.faTag,
          route: '/sc/trx-viewer/TRX_RB',
          precedence: 39,
        },
        {
          id: 'trxFa',
          displayName: 'Financial Adjustments',
          role: 'SC_TRX_FA_VIEW',
          icon: fas.faTag,
          route: '/sc/trx-viewer/TRX_FA',
          precedence: 40,
        },
      ],
    },

    // External Data
    {
      id: 'extData',
      displayName: 'External Data',
      role: 'SC_EXT_DATA_VIEW',
      icon: fas.faListUl,
      precedence: 35,
      children: [
        {
          id: 'scBrgDupDiscCheck',
          displayName: 'BRG Duplicate Checks',
          role: 'SC_BRG_DUP_DISC_CHECK_VIEW',
          icon: fas.faClipboard,
          route: '/sc/brg-dup-disc-check',
          precedence: 36,
        },
      ],
    },

    // Common Menus
    ...SidenavUtils.commonMenus('sc'),
  ],
};

export default scSideNav;
